/* JS AI Search part 3: ask, askIntent and the answer pipeline. Loaded in order with the other js-ai-*.js files (see snippets/js-ai-search-boot.liquid).
   Overview and switches: see the header of js-ai-1-nlp.js. */
(function (root) {
  'use strict';
  var X = root.JSAIX = root.JSAIX || {};
  var MAX_QUERY_CHARS = X.MAX_QUERY_CHARS, cleanText = X.cleanText, tokenize = X.tokenize, stem = X.stem, parseBudget = X.parseBudget,
      Engine = X.Engine, newReply = X.newReply, toItem = X.toItem, r4 = X.r4, cmpStr = X.cmpStr;
  Engine.prototype.ask = function (query, limit) {
    limit = limit === undefined ? 5 : limit;
    var original = cleanText(query).slice(0, MAX_QUERY_CHARS);
    var reply = newReply(original);
    if (!original) return reply;
    var self = this;
    if (tokenize(original).some(function (t) { return self.K.medicalStems[stem(t)]; })) { reply.refusedMedical = true; return reply; }
    var b = parseBudget(original);
    var rawTokens = tokenize(b.rest);
    var cheap = rawTokens.some(function (t) { return self.K.cheap[t]; });
    var parts = this._splitParts(b.rest);
    var kept = rawTokens.filter(function (t) { return !self.K.stop[t] && !self.K.cheap[t] && !(t.length === 1 && /[a-z]/.test(t)); });
    this._answer(reply, kept, { min: b.min, max: b.max, present: b.present }, cheap, limit, parts);
    return reply;
  };

  /** Run an AI-interpreted request through the same grounded pipeline. */
  Engine.prototype.askIntent = function (intent, limit) {
    limit = limit === undefined ? 5 : limit;
    var self = this, words = [];
    (intent.terms || []).forEach(function (t) { words = words.concat(tokenize(String(t).slice(0, 60))); });
    var kept = words.filter(function (t) { return !self.K.stop[t] && !(t.length === 1 && /[a-z]/.test(t)); }).slice(0, 12);
    var toP = function (v) { return v === null || v === undefined || v === '' ? null : Math.round(parseFloat(v) * 100); };
    var budget = { min: toP(intent.min_price), max: toP(intent.max_price) };
    budget.present = budget.min !== null || budget.max !== null;
    var reply = newReply(kept.join(' '));
    this._answer(reply, kept, budget, !!intent.cheapest, limit, []);
    return reply;
  };

  var SPLIT_RE = /\s(?:and|plus|with|n|&|\+)\s/;
  Engine.prototype._splitParts = function (text) {
    var self = this, parts = [];
    (' ' + String(text).toLowerCase() + ' ').split(SPLIT_RE).forEach(function (piece) {
      var words = tokenize(piece).filter(function (t) { return !self.K.stop[t] && !self.K.cheap[t] && !(t.length === 1 && /[a-z]/.test(t)); });
      if (words.length) parts.push(words);
    });
    return parts;
  };

  Engine.prototype._answer = function (reply, kept, budget, cheap, limit, parts) {
    var self = this;
    reply.budgetMin = budget.min; reply.budgetMax = budget.max;
    var stems = [];
    kept.forEach(function (raw) {
      var s = stem(raw), fixed = self._correct(s);
      if (fixed !== s) reply.corrections.push([raw, fixed]);
      stems.push(fixed);
    });
    reply.unknownTerms = stems.filter(function (s) { return !self.known[s]; });
    var concepts = this._concepts(stems);
    reply.concepts = concepts.map(function (c) { return c.label; });
    if (!concepts.length) {
      if (budget.present) this._browse(reply, budget, limit);
      return;
    }
    var results = this._match(concepts);
    var strict = results.filter(function (r) { return r.matched === concepts.length; });
    var kind = 'match', chosen = strict;
    if (!strict.length && concepts.length >= 2) {
      chosen = results.filter(function (r) { return r.matched >= concepts.length - 1; });
      kind = 'partial';
    }
    reply.kind = kind;
    var kept2 = [], soldOut = [];
    chosen.forEach(function (r) {
      var p = r.doc.p;
      if (!p.available) { reply.excludedOutOfStock++; soldOut.push(r.doc); return; }
      if (budget.max !== null && p.min > budget.max) { reply.excludedOutOfRange++; return; }
      if (budget.min !== null && p.max < budget.min) { reply.excludedOutOfRange++; return; }
      kept2.push(r);
    });
    kept2.forEach(function (r) { r.brand = self._brandHit(r.doc, concepts) ? 0 : 1; });
    kept2.sort(function (x, y) {
      var a = x.doc.p, b = y.doc.p, rx = -r4(x.score), ry = -r4(y.score);
      if (cheap) return x.brand - y.brand || a.min - b.min || rx - ry || cmpStr(a.title.toLowerCase(), b.title.toLowerCase()) || cmpStr(a.id, b.id);
      if (budget.max !== null) return rx - ry || x.brand - y.brand || b.min - a.min || cmpStr(a.title.toLowerCase(), b.title.toLowerCase()) || cmpStr(a.id, b.id);
      return rx - ry || x.brand - y.brand || a.min - b.min || cmpStr(a.title.toLowerCase(), b.title.toLowerCase()) || cmpStr(a.id, b.id);
    });
    kept2.slice(0, Math.max(0, limit)).forEach(function (r) { reply.items.push(toItem(r.doc.p, kind)); });
    if (budget.max !== null && parts.length >= 2 && !(strict.length && reply.items.length)) {
      this._bundles(reply, parts, budget, limit);
      if (reply.bundles.length && kind === 'partial') reply.items = [];
    }
    if (!reply.items.length && !reply.bundles.length && soldOut.length) {
      reply.soldOutTitles = soldOut.slice(0, 5).map(function (d) { return d.p.title; });
      this._alternatives(reply, soldOut, budget, limit);
    }
    var any = reply.items.length || reply.bundles.length || reply.alternatives.length;
    reply.needsAi = (reply.unknownTerms.length > 0 && !reply.refusedMedical && (kind === 'partial' || !any)) || (!any && kept.length >= 3);
  };

})(window);